import React, { Component, ReactNode } from "react";
import "./ErrorBoundary.css";
import * as Sentry from "@sentry/react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  eventId: string | null;
  isRefreshing: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, eventId: null, isRefreshing: false };
  }

  static getDerivedStateFromError(error: any): Partial<State> {
    const stored = JSON.parse(sessionStorage.getItem("errorsInstances") || "{}");
    if (stored?.[error?.toString()] === 1) {
      return { isRefreshing: true };
    }
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const errorKey = "errorsInstances";
    const stored = JSON.parse(sessionStorage.getItem(errorKey) || "{}");
    const errorMessage = error.toString();

    if (stored[errorMessage]) {
      stored[errorMessage] += 1;
    } else {
      stored[errorMessage] = 1;
    }
    sessionStorage.setItem(errorKey, JSON.stringify(stored));

    if (stored[errorMessage] === 1) {
      this.setState({ isRefreshing: true }, () => {
        window.location.reload();
      });
      return;
    }

    const eventId = Sentry.captureException(error, { extra: { errorInfo } });
    this.setState({
      hasError: true,
      eventId: eventId,
      isRefreshing: false,
    }); 
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {

    if (this.state.isRefreshing) {
      return (
        <div className="container">
          <div className="error-box"></div>
        </div>
      );
    }

    if (this.state.hasError) {
      return (
        <div className="container">
          <div className="error-box">
            <div>
              <h1>
                Oops! We cannot process your request at the moment, please try
                again later.
              </h1>
              <p>
                We are working to fix it. Please try refreshing the page or
                clear your browsing data for smooth experience.
              </p>
              <div className="error-id">Error ID: {this.state.eventId}</div>
              <p>
                If the issue continues, please email us at{" "}
                <a href="mailto:support@insta-pay.ch">support@insta-pay.ch</a>{" "}
                with the Error ID, your username, and phone number for further
                assistance.
              </p>
              <button
                style={{ marginTop: "30px" }}
                onClick={this.handleReload}
                className="error-button"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
